<template>
  <v-container style="min-height: calc(100vh - 80px);" class="my-5">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="12">
            <v-tabs centered>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailposttugasMhs', query: { post: check.post, class: check.class } }"
                exact>
                <v-icon left>mdi-book</v-icon> Tugas
              </v-tab>
              <v-tab
                class="text-capitalize"
                :to="{ name: 'DetailtugaskumpulMhs', query: { post: check.post, class: check.class } }"
                exact>
                <v-icon left>mdi-checkbox-multiple-marked-outline</v-icon> Pengumpulan tugas
              </v-tab>
            </v-tabs>
          </v-col>
          <v-col cols="12" md="12" v-if="alertdata.show">
            <alertsp :alertdata="alertdata" class="mb-0"></alertsp>
          </v-col>
          <v-col cols="12" md="12" v-if="loading.detail" class="text-center">
            <v-progress-circular
              :width="3"
              color="red"
              indeterminate>
            </v-progress-circular>
          </v-col>
          <v-col cols="12" md="12" v-if="!loading.detail && detaildata.length > 0">
            <v-row>
              <v-col cols="12" md="7">
                <v-card
                  flat>
                  <v-card-text>
                    <v-row class="black--text">
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" md="12">
                            <v-card flat>
                              <v-app-bar flat color="transparent" dense>
                                <v-toolbar-title class="font-weight-bold primary--text">
                                  {{ detaildata[0].title_post }}
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                              </v-app-bar>
                              <v-card-text class="pt-0">
                                <div>
                                  {{ detaildata[0].user_firstname }} {{ detaildata[0].user_lastname }} - {{ detaildata[0].posted_at_post }}
                                </div>
                                <div class="font-weight-bold mb-3">
                                  Batas pengumpulan: {{ detaildata[0].duedate_post }}
                                </div>
                                <v-divider></v-divider>
                                <div class="my-3 content-editor" v-html="detaildata[0].desc_post"></div>
                                <div class="font-weight-bold">
                                  Lampiran:
                                </div>
                                <div>
                                  <v-tabs v-model="tabtugas">
                                    <v-tab
                                      v-if="detaildata[0].url_post"
                                      class="text-capitalize"
                                      href="#tugas-video">
                                      Video
                                    </v-tab>
                                    <v-tab
                                      v-if="detaildata[0].file_post"
                                      class="text-capitalize"
                                      href="#tugas-file">
                                      File
                                    </v-tab>
                                  </v-tabs>
                                  <v-tabs-items :touchless="true" v-model="tabtugas">
                                    <v-tab-item
                                      v-if="detaildata[0].url_post"
                                      value="tugas-video">
                                      <v-card flat>
                                        <v-card-text>
                                          <vue-plyr>
                                            <div class="plyr__video-embed">
                                              <iframe
                                                :src="detaildata[0].url_post"
                                                allowfullscreen
                                                allowtransparency
                                                allow="autoplay">
                                              </iframe>
                                            </div>
                                          </vue-plyr>
                                        </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                    <v-tab-item
                                      v-if="detaildata[0].file_post"
                                      value="tugas-file">
                                      <v-card flat>
                                        <v-card-text>
                                          <a
                                            :href="detaildata[0].urlmateri"
                                            target="_blank">
                                            View attachment file
                                          </a>
                                          <iframe
                                            :src="getPdfView(detaildata[0].urlmateri)"
                                            style="width:100%; height:700px;"
                                            frameborder="0">
                                          </iframe>
                                        </v-card-text>
                                      </v-card>
                                    </v-tab-item>
                                  </v-tabs-items>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="5">
                <v-card
                  flat>
                  <v-card-text>
                    <v-row class="black--text">
                      <v-col cols="12" md="12">
                        <h6 class="text-h6">Unggah jawaban</h6>
                        <v-divider class="my-1"></v-divider>
                        <v-form
                          @submit.prevent="submitTugas"
                          ref="formsubmittugas"
                          v-model="formadd.tugas"
                          lazy-validation>
                          <v-row justify="center" class="black--text">
                            <v-col cols="12" md="12">
                              <v-row>
                                <v-col cols="12" md="12">
                                  <v-card class="my-2" outlined v-if="detailansw.length > 0">
                                    <v-card-text>
                                      <div class="text-decoration-underline">Jawaban yang telah anda submit:</div>
                                      <div class="black--text content-editor" v-html="detailansw[0].text_answ"></div>
                                      <a
                                        v-if="detailansw[0].file_answ"
                                        :href="detailansw[0].urlanswer"
                                        target="_blank">
                                        View attachment file
                                      </a>
                                      <div class="caption">
                                        at. {{ detailansw[0].post_at_answ }}
                                      </div>
                                      <v-chip
                                        class="mr-1"
                                        small
                                        :color="detailansw[0].islate ? 'error' : 'success'">
                                        {{ detailansw[0].islate ? 'Terlambat' : 'Tepat waktu' }}
                                      </v-chip>
                                      <v-chip
                                        small
                                        color="primary">
                                        Grade: {{ detailansw[0].grade_answ }}/100
                                      </v-chip>
                                      <div class="mt-3">
                                        <div class="text-decoration-underline">
                                          Komentar dosen:
                                        </div>
                                        <div
                                          class="content-editor"
                                          v-html="detailansw[0].feedback_answ ? detailansw[0].feedback_answ : '-'">
                                        </div>
                                      </div>
                                    </v-card-text>
                                  </v-card>
                                  <vue-editor
                                    v-model="addtugas.text_answ"
                                    placeholder="Jawaban text"
                                    :editorToolbar="customToolbar"
                                    class="custom-h-editor">
                                  </vue-editor>
                                  <v-file-input
                                    v-model="addtugas.file_answ"
                                    :rules="rules.files"
                                    accept=".pdf"
                                    name="file_answ"
                                    placeholder="Select file"
                                    label="Jawaban file"
                                    show-size>
                                  </v-file-input>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="12" md="12">
                              <alertsp :alertdata="alertupdate"></alertsp>
                              <v-btn
                                large
                                block
                                :loading="loading.addtugas"
                                :disabled="loading.addtugas || !formadd.tugas"
                                :color="maincolor"
                                class="white--text"
                                type="submit">
                                Unggah
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" md="12">
            <div class="mt-5 text-center">
              <v-btn
                class="mr-2 mb-2"
                fab
                depressed
                dark
                x-small
                :to="{ name: 'DetailclassworkMhs', query: { class: check.class } }">
                <v-icon dark>
                  mdi-arrow-left-thick
                </v-icon>
              </v-btn>
              <span class="title">Kembali ke kelas</span>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { getGdriveView } from '@/plugins/utils';
import { VueEditor } from 'vue2-editor';
import { mapState } from 'vuex';

export default {
  name: 'DetailtugaskumpulMhs',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      detail: false,
      teacher: false,
      student: false,
      addtugas: false,
      getansw: false,
    },
    api: process.env.VUE_APP_API,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    publickey: '123',
    detaildata: [],
    detailansw: [],
    teacherlist: [],
    studentlist: [],
    panduan: null,
    paramclass: {
      search: '',
      limit: '',
      offset: '',
    },
    addtugas: {
      file_answ: null,
      text_answ: '',
    },
    check: {
      class: '',
      post: '',
    },
    formcheck: {
      valid: false,
    },
    formadd: {
      tugas: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      files: [
        (value) => !value || value.size < 5000000 || 'Files less than 5 MB!',
      ],
    },
    hasil: {
      headers: [
        { text: 'Tahun', value: 'tahun_prestasi' },
        { text: 'Peringkat', value: 'juara_prestasi' },
        { text: 'Tingkat', value: 'tingkat_prestasi' },
      ],
      data: [],
    },
    tabtugas: null,
    customToolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link', 'code-block'],
      ['clean'],
    ],
  }),
  watch: {
    '$route.query.class'(val) {
      if (val) {
        this.check.class = val;
      }
    },
    '$route.query.post'(val) {
      if (val) {
        this.check.post = val;
        this.getPost();
      }
    },
  },
  mounted() {
    if (this.$route.query.class && this.$route.query.class !== '') {
      this.check.class = this.$route.query.class;
    }
    if (this.$route.query.post && this.$route.query.post !== '') {
      this.check.post = this.$route.query.post;
      this.getPost();
    }
  },
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  methods: {
    isLate(ds1, ds2) {
      const d1 = Date.parse(ds1);
      const d2 = Date.parse(ds2);
      let late = false;
      if (d1 < d2) {
        late = true;
      }
      return late;
    },
    submitTugas() {
      this.alertupdate.show = false;
      // console.log(this.addtugas);
      if (this.$refs.formsubmittugas.validate()) {
        if (this.tokenscr) {
          this.loading.addtugas = true;
          const dataadd = this.addtugas;
          const formData = new FormData();
          // file image
          formData.append('file_answ', dataadd.file_answ);
          formData.append('post', this.check.post);
          formData.append('textansw', dataadd.text_answ);
          // send data
          this.axios
            .post(
              this.api + '/api/answer/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              // console.log(res);
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.$refs.formsubmittugas.reset();
                  this.addtugas.text_answ = '';
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = 'Jawaban berhasil di unggah';
                  this.getAnswer();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.addtugas = false;
            })
            .catch((error) => {
              this.loading.addtugas = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    getPdfView(url) {
      return getGdriveView(url);
    },
    getPost() {
      this.loading.detail = true;
      this.alertdata.show = false;
      if (this.check.class && this.check.post && this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/post/student/' + this.check.post + '/' + this.check.class,
            {
              params: {},
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detaildata = resdata.data;
                this.detaildata[0].urlmateri = this.api + '/upload/post/' + this.detaildata[0].file_post;
                this.getAnswer();
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = resdata.message;
              }
            } else {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            }
            this.loading.detail = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.detail = false;
            this.alertdata.show = true;
            this.alertdata.type = 'error';
            this.alertdata.text = 'Internal services error!';
          });
      } else {
        this.loading.detail = false;
        this.alertdata.show = true;
        this.alertdata.type = 'error';
        this.alertdata.text = 'Data tidak ditemukan!';
      }
    },
    getAnswer() {
      this.loading.getansw = true;
      if (this.check.post && this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/answer/student/' + this.check.post,
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.detailansw = resdata.data;
                this.detailansw[0].urlanswer = this.api + '/upload/answer/' + this.detailansw[0].file_answ;
                this.detailansw[0].islate = this.isLate(this.detaildata[0].duedate_post, resdata.data[0].post_at_answ);
              }
            }
            this.loading.getansw = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getansw = false;
          });
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
